module.exports = new __parcel__URL__("hontar_x1.f1dd085d.webp").toString();